import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast, Button } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import close from '../../../static/images_cso/close.png';
import inConstruction from '../../../static/images_cso/inConstruction.png';

const api = new ApiCore();

const InConstruction = (props: any, refs: any) => {

    const [showDialog, setShowDialog] = useState<boolean>(false);

    useEffect(() => {
        return () => {
        }
    }, [])

    // 展示弹框
    useImperativeHandle(refs, () => ({
        toShow,
        toClose
    }));

    const toShow = () => {
        setShowDialog(true);
    }

    const toClose = () => {
        setShowDialog(false);
    }

    return (
        <div className={styles.in_construction_content} style={{ display: showDialog ? 'block' : 'none' }}>
             <div className={styles.dialog}>
                <div className={styles.shop_wrap}>
                    <img src={inConstruction} alt="" />
                </div>
                <div className={styles.close_wrap}>
                    <img src={close} onClick={toClose} alt="" />
                </div>
             </div>
             <div className={styles.mask}></div>
        </div>
    )
}

export default forwardRef(InConstruction);